/** Live player count for one server, as returned by `/api/status`. */
export type LiveCount = { online: number; max: number };
/** Map of server slug → live count (slugs whose server didn't respond are omitted). */
export type LiveStatus = Record<string, LiveCount>;

export type Server = {
  slug: string;
  name: string;
  meta: string;
  /** rgb triple used for the band tint + status dot */
  tint: string;
  /** optional banner image; the tint gradient is layered on top as a colored overlay */
  image?: string;
  /** per-server external GitBook wiki — server bands link here */
  wiki: string;
};

export const SERVERS: Server[] = [
  {
    slug: "atm10",
    name: "All the Mods 10 Modpack",
    meta: "Minecraft Modded Survival · 1.21.1 · atm10.infinity-city.de",
    image: "server-atm10.webp",
    tint: "245,233,6",
    wiki: "https://infinity-city.gitbook.io/atm10",
  },
  {
    slug: "fivem",
    name: "GTA V Roleplay",
    meta: "Aktuell in Entwicklung · Alpha 1.0", // FiveM · Realistisches Roleplay · fivem.infinity-city.de
    image: "server-fivem.webp",
    tint: "255,113,0",
    wiki: "https://infinity-city.gitbook.io/fivem",
  },
];
